/* import __COLOCATED_TEMPLATE__ from './input-element.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  type: 'text',
  selectPaddingBuffer: 0,
  // open - passed in
  // filterChanged - passed in

  actions: {
    focusOut() {
      // This is only here as a bugfix. See the description of
      // https://go.sqprod.co/sq-field-input-searchable-bugfix-pr
      // for more information.
    }
  }
});